import * as types from "./actionTypes";
import { INIT_INTERNET_CONNECTION_STATUS } from "./actionTypes";

export const get = () => {
  return {
    type: types.INIT_REQUEST
  };
};

export const getSuccess = (data, projectStatus = false) => {
  return {
    type: types.INIT_SUCCESS,
    payLoad: data
    // payLoad: { data: data, loading: false, project_status: projectStatus }
  };
};

export const getFailure = data => {
  return {
    type: types.INIT_FAILURE,
    payLoad: data
  };
  // if (data && data.data && data.data.project) {
  //   return {
  //     type: types.INIT_FAILURE,
  //     payLoad: { data: data, loading: false }
  //   };
  // } else {
  //   return {
  //     type: types.INIT_FAILURE,
  //     payLoad: { loading: false, userNotVerified:userNotVerified }
  //   };
  // }
};

export const sentHelpStatus = data => {
  return {
    type: types.INIT_HELP_STATUS,
    payLoad: data
  };
};

export const changeServerInterruptStatus = (message = "") => {
  return {
    type: INIT_INTERNET_CONNECTION_STATUS,
    payLoad: { serverInterruptMessage: message }
    // payLoad:{serverInterruptStatus: status}
  };
};

export const completeUserInfoConfirmData = data => {
  return {
    type: types.COMPLETE_USER_INFO_CONFIRM_DATA,
    data: data
  };
};

export const completeUserInfoConfirmClose = () => {
  return {
    type: types.COMPLETE_USER_INFO_CONFIRM_CLOSE
  };
};

export const completeProjectInfoConfirmData = data => {
  return {
    type: types.COMPLETE_PROJECT_INFO_CONFIRM_DATA,
    data: data
  };
};

export const completeProjectInfoConfirmClose = changeCookie => {
  return {
    type: types.COMPLETE_PROJECT_INFO_CONFIRM_CLOSE,
    changeCookie: changeCookie
  };
};

export const accountTitleLevelUpdate = data => {
  return {
    type: types.ACCOUNT_TITLE_LEVEL_UPDATE_REQUEST,
    data
  };
};

export const accountTitleLevelUpdateSuccess = data => {
  return {
    type: types.ACCOUNT_TITLE_LEVEL_UPDATE_SUCCESS,
    data: data
  };
};

export const accountTitleLevelUpdateFailure = () => {
  return {
    type: types.ACCOUNT_TITLE_LEVEL_UPDATE_FAILURE
  };
};

export const useImprestSequenceUpdate = data => {
  return {
    type: types.USE_IMPREST_SEQUENCE_REQUEST,
    data
  };
};

export const useImprestSequenceUpdateSuccess = data => {
  return {
    type: types.USE_IMPREST_SEQUENCE_SUCCESS,
    data: data
  };
};

export const useImprestSequenceUpdateFailure = () => {
  return {
    type: types.USE_IMPREST_SEQUENCE_FAILURE
  };
};

export const connectWithApi = data => {
  return {
    type: types.CONNECT_WITH_API_REQUEST,
    data
  };
};

export const connectWithApiSuccess = data => {
  return {
    type: types.CONNECT_WITH_API_SUCCESS,
    data: data
  };
};

export const connectWithApiFailure = () => {
  return {
    type: types.CONNECT_WITH_API_FAILURE
  };
};

export const connectToPartner = data => {
  return {
    type: types.CONNECT_TO_PARTNER_REQUEST,
    data
  };
};

export const connectToPartnerSuccess = data => {
  return {
    type: types.CONNECT_TO_PARTNER_SUCCESS,
    data: data
  };
};

export const connectToPartnerFailure = () => {
  return {
    type: types.CONNECT_TO_PARTNER_FAILURE
  };
};

export const transactionDateLimitStore = data => {
  return {
    type: types.PROJECT_TRANSACTION_DATE_LIMIT_REQUEST,
    data
  };
};

export const transactionDateLimitStoreSuccess = data => {
  return {
    type: types.PROJECT_TRANSACTION_DATE_LIMIT_SUCCESS,
    data: data
  };
};

export const transactionDateLimitStoreFailure = () => {
  return {
    type: types.PROJECT_TRANSACTION_DATE_LIMIT_FAILURE
  };
};
